import { render, staticRenderFns } from "./OptinModal.vue?vue&type=template&id=51063278&scoped=true"
import script from "./OptinModal.vue?vue&type=script&lang=js"
export * from "./OptinModal.vue?vue&type=script&lang=js"
import style0 from "./OptinModal.vue?vue&type=style&index=0&id=51063278&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51063278",
  null
  
)

export default component.exports